<template>
	<div>
		<div class="search" :class="{'dark':themeName=='dark'}">
			<div class="leftcss"><a @click='goBack'><i class="iconfont icon---"></i></a> </div> 
			<div class="searchcss" :class="{'dark':themeName=='dark'}"><input class="searchinput" :class="{'dark':themeName=='dark'}" v-model='search' ref="clearText" /> <span class="searchx" @click="clearText"><i class="iconfont icon-guanbi"></i></span></div>
			<div class="rightcss"><router-link to="/"><i class="iconfont icon-yemian"></i></router-link></div>
			</div>
			<div class="search-main">
				<ul >
					<li class="martop" v-for="item in result">
						<router-link :to="'/daozang'+item.nid+'-'+item.id">{{item.title}}</router-link>
					</li>
				</ul>
			</div> 
		</div>
</template>

<script>
	// @ is an alias to /src
	import axios from 'axios'
	export default {

		data() {
			return {
				search: '',
				result: ''
			}
		},
		methods: {
			clearText: function() {
				this.$refs.clearText.value = '';
				this.search = ''
			},
			goBack() {
				window.history.length > 1 ?
					this.$router.go(-1) :
					this.$router.push('/')
			}
		},
		watch: {
			search: function(val) {
				var _self = this;
				val = val.replace(/\s*/g,"");
				if (val) {
					axios.get('https://m.daorenjia.com/api/apisearch.php?info=' + val).then(function(response) {
						//console.log(response); 
						_self.result = response.data
					})
				} else {
					_self.result = ''
				}
			}
		},

	}
</script>
<style>
.search{
height:44px;
		margin:0 auto;
		background-color: #0A98D5; 
		color: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content:space-between;
		width: 100%;
		padding-top: 3px;
	}
	.search.dark{
		background-color: #333333; 
		color:#808080
	}
	.search-main{
		margin: 3vh;
		min-height: 100vh;
	}
	.search-main.dark{
 background-color: #1A1714;
 color: #808080;
 }
.searchcss{
	 background-color: #FFFFFF;
	 width: 70%;
	 height:35px;
	 display: flex;
	 align-items: center;
	 justify-content: space-between;
}
.searchcss.dark{
		background-color: #1A1714; 
		color:#808080
	}
.searchx{
	color: #808080;
	margin-right: 2vw;
}
.searchinput{
	border:0;
	margin: 0;
	padding: 0;
	width: 65vw;
	min-height: 3.5vmax;
	background-color:transparent;
}
.searchinput.dark{
	 
		color:#808080
	}
.searchinput:focus{
	outline:none;
}


</style>
